module.exports = "/images/news-release.svg?e2e1f2f264559a7062ef8f77c445bb01";